import { render, staticRenderFns } from "./myText.vue?vue&type=template&id=7af508e5&scoped=true"
import script from "./myText.vue?vue&type=script&lang=js"
export * from "./myText.vue?vue&type=script&lang=js"
import style0 from "./myText.vue?vue&type=style&index=0&id=7af508e5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af508e5",
  null
  
)

export default component.exports